import { FormlyFieldConfig } from "@ngx-formly/core";
import { AllegatiIntegrazioneStep } from "app/forms/shared/allegati-integrazione.step";
import { IntestatarioIntegrazioneStep } from "app/forms/shared/intestatario-integrazione.step";
import { PrivacyComunicazioneStep } from "app/forms/shared/privacy-comunicazione";

export const TrasmissioneIntegrazione: FormlyFieldConfig[] =
 [
            {
                props: {
                    slabel: "PRIVACY",
                },
                wrappers: ['panel-step'],
                fieldGroup: PrivacyComunicazioneStep
            },
            {
                props: {
                    slabel: "INTESTATARIO",
                },
                wrappers: ['panel-step'],
                fieldGroup: IntestatarioIntegrazioneStep
            },
            {
                props: {
                    slabel: 'ALLEGATI',
                },
                wrappers: ['panel-step'],
                fieldGroup: AllegatiIntegrazioneStep
            },

        ]
